import React, { useEffect } from "react"

export function LetsWorkTogether() {
  useEffect(() => {
    document.body.style.backgroundColor = ""
    document.body.style.color = ""
  }, [])

  return (
    <div className="lwt-page">
      <div className="lwt-left">
        <p className="eyebrow">Get in touch</p>
        <h1 className="inner-page-headline">Have ideas with us.</h1>
        <a href="mailto:hello@presentfuture.uk" className="lwt-email">hello@presentfuture.uk</a>
      </div>

      <div className="lwt-right">
        <video
          className="lwt-video"
          src="/bright-spark.mp4"
          autoPlay
          muted
          playsInline
        />
      </div>
    </div>
  )
}
